import { put, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_APPLICATION_DETAIL_VALID,
    UPDATE_APPLICATION_FORM_DETAIL_VALID,
    UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
    UPDATE_FORM_VALIDITY,
    UPDATE_SITE_INFO_INSIDE_VALIDITY,
} from 'store/key';
import { produce } from 'utility/general';

const getSiteInfoDefaultState = () => ({
    teamMember: false,
    personalParticulars: false,
    outlineOfApplication: false,
    studyDetails: false,
    studyDetailsForProspectiveStudy: false,
    ethicalImplications: false,
    budgetResources: false,
    documentUploadValid: false,
    declarationAndEndorsementValid: false,
});

const getSiteInfoInsideValidDefaultState = {
    declareInvValid: true /** check declaration's table rows of auto-filled for completeness when click "Save" button */,
    declareStudentValid: true /** check declaration's table rows of auto-filled for completeness when click "Save" button */,
    declareInvCompleted: true,
    HAEndorsementCompleted: true,
    universitiesEndorsementCompleted: true,
    HAUniversitiesEndorsementCompleted: true,
};

const getInitialState = () => ({
    isApplicationFormDetailValid: {
        instruction: false,
        teamMember: false,
        // personalParticulars: false,
        outlineOfApplication: false,
        studyDetails: false,
        studyDetailsForProspectiveStudy: false,
        ethicalImplications: false,
        budgetResources: false,
        clinicalStudyCategorizationFormValid: false,
        documentUploadValid: false,
    },
    siteInfoValid: {},
    siteInfoInsideValid: {} /** includes each siteInfo form's inside validation */,
    clickedSubmit: false /** clickedSubmit = true when click "Submit" button */,
    clickedSave: false /** clickedSave = true when click "Save" button */,
});

function* updateApplicationFormDetailValid(action) {
    const { applicationDetailValid } = yield select();

    if (!action.payload) return;
    for (let key in action.payload) {
        applicationDetailValid.isApplicationFormDetailValid[key] = action.payload[key];
    }
    yield put({
        type: SET_APPLICATION_DETAIL_VALID,
        payload: applicationDetailValid,
    });
}

function* updateState(action) {
    const { applicationDetailValid } = yield select();
    if (action.payload === undefined) return;

    for (let key in action.payload) {
        applicationDetailValid[key] = action.payload[key];
    }
    yield put({
        type: SET_APPLICATION_DETAIL_VALID,
        payload: applicationDetailValid,
    });
}

function* updateFormValidity(action) {
    const { applicationDetailValid, applicationDetail } = yield select();
    // type is either study or site
    const { type, formKey, isValid, siteInfoId, applicationFormId } = action.payload;

    applicationDetailValid.applicationFormId = applicationFormId;

    if (type === 'study') {
        applicationDetailValid.isApplicationFormDetailValid[formKey] = isValid;
    } else if (type === 'site') {
        const applicationDetailForm = applicationDetail[applicationFormId];
        const listOfSiteId = applicationDetailForm.siteInfo.map((item) => item.id);

        if (listOfSiteId.includes(siteInfoId)) {
            if (!applicationDetailValid.siteInfoValid[siteInfoId]) {
                applicationDetailValid.siteInfoValid[siteInfoId] = getSiteInfoDefaultState();
            }

            applicationDetailValid.siteInfoValid[siteInfoId][formKey] = isValid;
        }
    } else {
        applicationDetailValid[formKey] = isValid;
    }

    yield put({
        type: SET_APPLICATION_DETAIL_VALID,
        payload: applicationDetailValid,
    });
}

function* updateSideInfoInsideValidity(action) {
    const { applicationDetailValid, applicationDetail } = yield select();

    const { formKey, isValid, siteInfoId, applicationFormId } = action.payload;

    const applicationDetailForm = applicationDetail[applicationFormId];

    const listOfSiteId = applicationDetailForm.siteInfo.map((item) => item.id);

    applicationDetailValid.applicationFormId = applicationFormId;

    // check if siteInfoId is valid and exist in the applicationForm before saving to store
    if (listOfSiteId.includes(siteInfoId)) {
        if (!applicationDetailValid.siteInfoInsideValid[siteInfoId]) {
            applicationDetailValid.siteInfoInsideValid[siteInfoId] = getSiteInfoInsideValidDefaultState;
        }

        applicationDetailValid.siteInfoInsideValid[siteInfoId][formKey] = isValid;

        yield put({
            type: SET_APPLICATION_DETAIL_VALID,
            payload: applicationDetailValid,
        });
    }
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_APPLICATION_DETAIL_VALID:
            // const { applicationFormId } = action.payload;

            // if (!applicationFormId || applicationFormId === -1) {
            //     throw new Error('application id is required to update reducer');
            // }

            // if (state.applicationFormId != applicationFormId) {
            //     state = getInitialState();
            //     state.applicationFormId = applicationFormId;
            // }

            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchApplicationDetailValid() {
    yield takeEvery(UPDATE_APPLICATION_FORM_DETAIL_VALID, safeSaga(updateApplicationFormDetailValid));
    yield takeEvery(UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE, safeSaga(updateState));
    yield takeEvery(UPDATE_FORM_VALIDITY, safeSaga(updateFormValidity));
    yield takeEvery(UPDATE_SITE_INFO_INSIDE_VALIDITY, safeSaga(updateSideInfoInsideValidity));
}

export default reducer;
